// Vues aériennes
import heroImage from './vue_aerienne.jpeg';
import vueAerienne1 from './vue_aerienne.jpeg';
import vueAerienne2 from './vue_aerienne_2.jpeg';
import vueAerienne3 from './vueaerienne(3).jpeg';

// Vues extérieures
import vue1 from './vue.jpeg';
import vue2 from './vue(2).jpeg';
import exterieur1 from './exterieur1.jpeg';
import exterieur2 from './exterieur2.jpeg';
import exterieur3 from './exterieur3.jpeg';
import exterieur4 from './exterieur4.jpeg';
import exterieurNiveau0 from './exterieur_niveau0.jpeg';
import exterieurNiveau0_2 from './exterieur_niveau0 (3).jpeg';
import exterieurNiveau1 from './exterieur_niveau1.jpeg';
import exterieurNiveau1_2 from './exterieur_niveau1(2).jpeg';
import exterieurNiveau1_3 from './exterieur_niveau1 (3).jpeg';

// Piscine
import piscine1 from './piscine.jpeg';
import piscine2 from './piscine(2).jpeg';
import piscine3 from './piscine(3).jpeg';
import piscine4 from './piscine(4).jpeg';
import piscine5 from './piscine(5).jpeg';

// Niveau 1 - Chambres
import chambre1_1 from './chambre1 (5).jpeg';
import chambre1_2 from './chambre1_3.jpeg';
import chambre1_3 from './chambre1_4.jpeg';
import chambre1_4 from './etage1_room1.jpeg';
import chambre2_1 from './chambre2.jpeg';
import chambre2_2 from './chambre2 (2).jpeg';
import chambre2_3 from './chambre_2 (4).jpeg';
import chambre2_4 from './chambre 2 (5).jpeg';

// Niveau 0 - Chambres
import chambre3_1 from './chambre3.jpeg';
import chambre3_2 from './chambre3_1.jpeg';
import chambre3_3 from './chambre3_2.jpeg';
import chambre3_4 from './chambre 3 (2).jpeg'; // Correction de l'espace dans le nom du fichier
import chambre3_5 from './chambre3(5).jpeg';
import chambre3_6 from './etage0_room3.jpeg';
import chambre4_1 from './chambre4.jpeg';
import chambre4_2 from './chambre 4 (4).jpeg';
import chambre4_3 from './etage0_room4.jpeg';
import chambre4_4 from './etage0_room4_2.jpeg';

// Niveau 1 - Salon
import salonNiveau1_1 from './salon_niveau1.jpeg';
import salonNiveau1_2 from './salon_niveau1(2).jpeg';
import salonNiveau1_3 from './salon_niveau1(3).jpeg';
import salonNiveau1_4 from './salon_niveau1(4).jpeg';
import salonNiveau1_5 from './salon_niveau1 (5).jpeg';
import salonNiveau1_6 from './etage1_salon1.jpeg';
import salonNiveau1_7 from './etage1_salon1_2.jpeg';
import salonNiveau1_8 from './etage1_salon1_3.jpeg';

// Niveau 0 - Séjour
import sejourNiveau0 from './sejour_niveau0.jpeg';

// Niveau 1 - Cuisine
import cuisineNiveau1_1 from './cuisine_niveau1.jpeg';
import cuisineNiveau1_2 from './cuisine_niveau1(2).jpeg';
import cuisineNiveau1_3 from './etage1_cuisine1.jpeg';

// Niveau 0 - Cuisine
import cuisineNiveau0_1 from './cuisine_niveau0.jpeg';
import cuisineNiveau0_2 from './cuisine_niveau0 (1).jpeg';
import cuisineNiveau0_3 from './Cuisine_niveau0 (2).jpeg';

// Niveau 1 - Salle de bain
import salleDeBainNiveau1 from './etage1_salledebain1.jpeg';

// Niveau 0 - Salle de bain
import salleDeBainNiveau0_1 from './salledebain_niveau0.jpeg';
import salleDeBainNiveau0_2 from './etage0_salledebain2.jpeg';

// Téléphone
import telImage from './tel.png';

// Exporter toutes les images
export {
  // Vues aériennes
  heroImage, vueAerienne1, vueAerienne2, vueAerienne3,
  
  // Vues extérieures
  vue1, vue2,
  exterieur1, exterieur2, exterieur3, exterieur4,
  exterieurNiveau0, exterieurNiveau0_2,
  exterieurNiveau1, exterieurNiveau1_2, exterieurNiveau1_3,
  
  // Piscine
  piscine1, piscine2, piscine3, piscine4, piscine5,
  
  // Niveau 1 - Chambres
  chambre1_1, chambre1_2, chambre1_3, chambre1_4,
  chambre2_1, chambre2_2, chambre2_3, chambre2_4,
  
  // Niveau 0 - Chambres
  chambre3_1, chambre3_2, chambre3_3, chambre3_4, chambre3_5, chambre3_6,
  chambre4_1, chambre4_2, chambre4_3, chambre4_4,
  
  // Niveau 1 - Salon
  salonNiveau1_1, salonNiveau1_2, salonNiveau1_3, salonNiveau1_4, 
  salonNiveau1_5, salonNiveau1_6, salonNiveau1_7, salonNiveau1_8,
  
  // Niveau 0 - Séjour
  sejourNiveau0,
  
  // Niveau 1 - Cuisine
  cuisineNiveau1_1, cuisineNiveau1_2, cuisineNiveau1_3,
  
  // Niveau 0 - Cuisine
  cuisineNiveau0_1, cuisineNiveau0_2, cuisineNiveau0_3,
  
  // Niveau 1 - Salle de bain
  salleDeBainNiveau1,
  
  // Niveau 0 - Salle de bain
  salleDeBainNiveau0_1, salleDeBainNiveau0_2
};

// Pour la compatibilité avec le code existant
export const exterior = exterieur1;
export const terrace = exterieur2;
export const livingRoom = salonNiveau1_1;
export const kitchen = cuisineNiveau1_1;
export const diningRoom = sejourNiveau0;
export const pool = piscine1;
export const room1 = chambre1_3;
export const room2 = chambre2_3;
export const room3 = chambre3_6;
export const room4 = chambre4_1;
export const bathroom1 = salleDeBainNiveau1;
export const bathroom2 = salleDeBainNiveau0_1;
export const garden = exterieurNiveau1; // Ajout pour la compatibilité avec GalleryPage

// Pour la compatibilité avec VillaPage
export const exterior1 = exterieur1;
export const livingRoom1 = salonNiveau1_1;
export const pool1 = piscine1;

// Téléphone
export const tel = telImage;
